module.exports = __webpack_public_path__ + "img/background-watermark_en.4f03bd7.jpg";